import React, {useRef, useState} from "react";
import Box from "@mui/material/Box";
import {Button, Divider, Grid, Stack} from "@mui/material";
import InputField from "../../components/InputField";
import AlertBar from "../../components/AlertBar";
import Form from "../../components/Form";
import {BASE_URL} from "../../constants";
import {reportErrors} from "../../helpers";
import SelectField from "../../components/SelectField";

const genders = [
    {label: "Male", value:"Male"},
    {label: "Female", value:"Female"},
];
export default function AddEmployee(props) {
    const form = useRef();
    const alert = useRef();
    const firstNameRef = useRef();
    const middleNameRef = useRef();
    const lastNameRef = useRef();
    const genderRef = useRef();
    const phoneRef = useRef();
    const emailRef = useRef();

    const [firstName, setFistName] = useState(props.data?.firstName);
    const [middleName, setMiddleName] = useState(props.data?.middleName);
    const [lastName, setLastName] = useState(props.data?.lastName);
    const [phone, setPhone] = useState(props.data?.phone);
    const [email, setEmail] = useState(props.data?.email);
    const [gender, setGender] = useState(props.data?.gender);
    const [canSubmit, setCanSubmit] = useState(true);
    const submit = () => {
        let data = {
            firstName,
            middleName,
            lastName,
            phone,
            email,
            gender
        }
        if (canSubmit && form.current.validate()) {
            setCanSubmit(false);
            alert.current.showProgress();
            if (props.data?.employeeId) {
                window.axios
                    .put(`${BASE_URL}api/settings/employee/${props.data?.employeeId}`, data)
                    .then(response => {
                        alert.current.showSuccess("Update Successfully.");
                        setCanSubmit(true);
                        setTimeout(() => {
                            props.modal.current.hide();
                            props.loadData();
                        }, 1000)
                    })
                    .catch(error => {
                        setCanSubmit(true);
                        reportErrors(alert.current, error);
                    });
            } else {
                window.axios
                    .post(`${BASE_URL}api/settings/employee`, data)
                    .then(response => {
                        alert.current.showSuccess("Create Successfully.");
                        setCanSubmit(true);
                        setTimeout(() => {
                            props.modal.current.hide();
                            props.loadData();
                        }, 1000)
                    })
                    .catch(error => {
                        setCanSubmit(true);
                        reportErrors(alert.current, error);
                    });
            }
        }
    }
    return (
        <Box>
            <Form ref={form}>
                <AlertBar ref={alert}/>
                <Grid container spacing={2} sx={{p: 1}}>
                    <Grid item xs={4}>
                        <InputField
                            required={true}
                            ref={firstNameRef}
                            defaultValue={firstName}
                            type="text"
                            label="First Name"
                            onChange={(value) => setFistName(value)}
                        />
                    </Grid>
                    <Grid item xs={4}>
                        <InputField
                            required={true}
                            ref={middleNameRef}
                            defaultValue={middleName}
                            type="text"
                            label="Middle Name"
                            onChange={(value) => setMiddleName(value)}
                        />
                    </Grid>
                    <Grid item xs={4}>
                        <InputField
                            required={true}
                            ref={lastNameRef}
                            defaultValue={lastName}
                            type="text"
                            label="Last Name"
                            onChange={(value) => setLastName(value)}
                        />
                    </Grid>
                    <Grid item xs={4}>
                        <InputField
                            required={true}
                            ref={phoneRef}
                            defaultValue={phone}
                            type="text"
                            label="Phone"
                            onChange={(value) => setPhone(value)}
                        />
                    </Grid>
                    <Grid item xs={4}>
                        <InputField
                            required={true}
                            ref={emailRef}
                            defaultValue={email}
                            type="text"
                            label="Email"
                            onChange={(value) => setEmail(value)}
                        />
                    </Grid>
                    <Grid item xs={4}>
                        <SelectField
                            ref={genderRef}
                            required={true}
                            label="Gender"
                            options={genders}
                            value={gender}
                            onChange={(value) => setGender(value)}
                        />
                    </Grid>
                    <Grid item xs={12}><Divider/></Grid>
                    <Grid item xs={12}>
                        <Stack alignItems="center"
                               justifyContent="center">
                            <Grid item xs={2}>
                                <Button
                                    disabled={!canSubmit}
                                    sx={{my: 1, textTransform: "none"}}
                                    disableElevation
                                    size="medium"
                                    variant="contained"
                                    color="primary"
                                    onClick={() => submit()}
                                >
                                    {props.data?.employeeId ? "Update" : "Save"}
                                </Button>
                            </Grid>
                        </Stack>
                    </Grid>
                </Grid>
            </Form>
        </Box>
    );
}